import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const RatingCard = () => {
  const navigate = useNavigate(); // Gunakan useNavigate untuk navigasi
  // State untuk melacak apakah tombol sudah diklik
  const [isClicked, setIsClicked] = useState(false);

  // Fungsi untuk navigasi ke halaman About dan scroll ke elemen dengan ID 'testimoni'
  const handleClick = () => {
    // Menandai bahwa tombol sudah diklik
    setIsClicked(true);

    // Navigasi ke halaman /about dan scroll ke elemen dengan ID 'testimoni'
    navigate('/about#testimoni'); // Menggunakan navigate dari react-router-dom

    // Reset animasi pulse setelah beberapa waktu (sesuaikan dengan durasi animasi pulse)
    setTimeout(() => {
      setIsClicked(false); // Reset state untuk animasi berikutnya
    }, 1000); // Durasi animasi pulse (1 detik)
  };

  return (
    <div>
      <section className="rating-card wow fadeInDown">
        <div className="image">
          <img src="./assets/img/FellaHD-300x300.jpg" alt="Experience Image" />
        </div>

        <div className="content stabilo1">
          <h3>
            <i
              className="fas fa-star"
              style={{ color: 'gold', marginRight: '8px' }}
            ></i>
            4.9/5.0 Rating
          </h3>
          <p>
            Pelanggan kami sangat puas dengan layanan yang kami berikan. Kami
            berkomitmen untuk menyediakan pengalaman terbaik.
          </p>
          <p>
            Kami memiliki pengalaman lebih dari 7 tahun dalam industri ini dan
            telah memberikan layanan yang luar biasa kepada lebih dari ribuan
            pelanggan.
          </p>
          {/* Tombol untuk scroll ke bagian testimoni */}
          <button
            className={`btn-rating ${isClicked ? 'pulsing' : ''}`} // Menambahkan kelas 'pulsing' jika tombol diklik
            onClick={handleClick} // Menambahkan onClick untuk memulai animasi dan scroll
          >
            Lihat Cerita Pengguna
          </button>
        </div>
      </section>
    </div>
  );
};

export default RatingCard;
